import angular from "angular";

import AuthService from './auth.service';
import EventService from './event.service';
import FocusService from './focus.service';
import SocketService from './socket.service';
import SessionService from './session.service';
import UserService from './user.service';

const services = angular.module('app.services',[])
    .service('AuthService',AuthService)
    .service('EventService',EventService)
    .service('FocusService',FocusService)
    .service('SessionService',SessionService)
    .service('SocketService',SocketService)
    .service('UserService',UserService)
    .name;

export default services;



// WEBPACK FOOTER //
// ./public/app/services/index.js